import { acceptedAttachmentsSummary } from "../constants/attachmentFileTypes";

// The axios interceptor rejects with response.data, so a 400 arrives as the API's own
// string. Rephrase the actionable ones; never discard a message the API did send.
export function attachmentUploadError(error: any): string {
    const message = typeof error === "string" ? error : error?.message ?? "";

    const badExtension = message.match(/File extension "(.*)" is invalid/i);
    if (badExtension) {
        const extension = badExtension[1];
        return extension
            ? `${extension} files can't be attached. ${acceptedAttachmentsSummary}`
            : `That file has no file type, so it can't be attached. ${acceptedAttachmentsSummary}`;
    }

    const badSignature = message.match(/Invalid file signature: (.*)/i);
    if (badSignature)
        return `"${badSignature[1]}" doesn't match the file type its name suggests, so it can't be attached.`;

    if (/File name is empty/i.test(message)) return "That file has no name, so it can't be attached.";

    if (message) return message;

    return "Could not attach the file. Please try again.";
}
